(() => {
  const headingSelector = 'h1, h2, h3, h4, h5, h6';
  const excludedHeadingParents = 'table, thead, tbody, tfoot, tr, td, th, li, details, summary';
  const meaningfulElementSelector = 'img, table, ul, ol, iframe, video, model-viewer, svg, canvas, blockquote';
  const initializedAttribute = 'data-product-description-accordion-initialized';

  const caretIcon = `
    <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
    </svg>
  `;

  const getSectionHeadings = (root) =>
    Array.from(root.querySelectorAll(headingSelector)).filter((heading) => !heading.closest(excludedHeadingParents));

  const hasVisibleContent = (nodes) =>
    nodes.some((node) => {
      if (node.nodeType === Node.TEXT_NODE) return node.textContent.trim().length > 0;
      if (node.nodeType !== Node.ELEMENT_NODE) return false;

      return (
        node.textContent.trim().length > 0 ||
        node.matches(meaningfulElementSelector) ||
        node.querySelector(meaningfulElementSelector)
      );
    });

  const appendFragmentIfVisible = (target, fragment) => {
    const nodes = Array.from(fragment.childNodes);

    if (hasVisibleContent(nodes)) {
      target.append(fragment);
    }
  };

  const createAccordion = (heading, index, sectionId) => {
    const title = heading.textContent.trim() || 'Details';
    const accordion = document.createElement('div');
    accordion.className = 'product__accordion product__description-accordion accordion quick-add-hidden';

    const details = document.createElement('details');
    details.id = `ProductDescriptionAccordion-${sectionId}-${index + 1}`;

    const summary = document.createElement('summary');
    summary.innerHTML = `
      <div class="summary__title">
        <h2 class="h4 accordion__title inline-richtext"></h2>
      </div>
      ${caretIcon}
    `;
    summary.querySelector('.accordion__title').textContent = title;

    const content = document.createElement('div');
    content.className = 'accordion__content rte';

    details.append(summary, content);
    accordion.append(details);

    return { accordion, content };
  };

  const buildDescriptionAccordions = (description) => {
    if (description.hasAttribute(initializedAttribute)) return;

    const headingNodes = getSectionHeadings(description);

    if (!headingNodes.length) {
      description.setAttribute(initializedAttribute, 'true');
      return;
    }

    const source = document.createElement('div');
    const fragment = document.createDocumentFragment();
    const sectionId = description.closest('[data-section]')?.getAttribute('data-section') || 'main';
    let accordionIndex = 0;

    while (description.firstChild) {
      source.append(description.firstChild);
    }

    while (source.firstChild) {
      const headings = getSectionHeadings(source);
      const heading = headings[0];

      if (!heading) {
        const remaining = document.createDocumentFragment();

        while (source.firstChild) {
          remaining.append(source.firstChild);
        }

        appendFragmentIfVisible(fragment, remaining);
        break;
      }

      const introRange = document.createRange();
      introRange.setStart(source, 0);
      introRange.setEndBefore(heading);
      appendFragmentIfVisible(fragment, introRange.extractContents());

      const nextHeading = headings[1];
      const { accordion, content } = createAccordion(heading, accordionIndex, sectionId);
      const contentRange = document.createRange();

      accordionIndex += 1;
      contentRange.setStartAfter(heading);

      if (nextHeading) {
        contentRange.setEndBefore(nextHeading);
      } else {
        contentRange.setEnd(source, source.childNodes.length);
      }

      appendFragmentIfVisible(content, contentRange.extractContents());
      heading.remove();
      fragment.append(accordion);
    }

    description.replaceChildren(fragment);
    description.setAttribute(initializedAttribute, 'true');
  };

  const initializeDescriptions = (root = document) => {
    root.querySelectorAll('[data-product-description-accordion]').forEach(buildDescriptionAccordions);
  };

  document.addEventListener('DOMContentLoaded', () => initializeDescriptions());
  document.addEventListener('shopify:section:load', (event) => initializeDescriptions(event.target));
})();
